import { render, staticRenderFns } from "./PrescriptionSummaryCategory.vue?vue&type=template&id=75fac930&scoped=true"
import script from "./PrescriptionSummaryCategory.vue?vue&type=script&lang=ts"
export * from "./PrescriptionSummaryCategory.vue?vue&type=script&lang=ts"
import style0 from "./PrescriptionSummaryCategory.vue?vue&type=style&index=0&id=75fac930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fac930",
  null
  
)

export default component.exports